import { Link } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { FOOTER_KEYS, NAV_KEYS } from "@/constants/translations";

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-2xl font-bold mb-6">Estancia Corta</h3>
            <p className="text-gray-400 leading-relaxed">
              {t(FOOTER_KEYS.DESCRIPTION)}
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-6">{t(FOOTER_KEYS.LINKS)}</h4>
            <ul className="space-y-3 text-gray-400">
              <li>
                <Link
                  to="/propiedades"
                  className="hover:text-white transition-colors"
                >
                  {t(NAV_KEYS.PROPERTIES)}
                </Link>
              </li>
              <li>
                <Link
                  to="/nosotros"
                  className="hover:text-white transition-colors"
                >
                  {t(NAV_KEYS.ABOUT)}
                </Link>
              </li>
              <li>
                <Link
                  to="/contacto"
                  className="hover:text-white transition-colors"
                >
                  {t(NAV_KEYS.CONTACT)}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-6">{t(FOOTER_KEYS.CONTACT)}</h4>
            <ul className="space-y-3 text-gray-400">
              <li>+52 3340 86 06 42</li>
              <li>pedro@estanciacorta.com</li>
              <li>Jalisco, México</li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-6">
              {t(FOOTER_KEYS.ESTANCIA_CORTA)}
            </h4>
            <ul className="space-y-3 text-gray-400">
              <li>
                <Link
                  to="/gestiondepropiedad"
                  className="hover:text-white transition-colors"
                >
                  {t(FOOTER_KEYS.MANAGEMENT)}
                </Link>
              </li>
              <li>
                <Link
                  to="/publicar"
                  className="hover:text-white transition-colors"
                >
                  {t(FOOTER_KEYS.PUBLISH)}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400">
          <p>
            &copy; 2025 Estancia Corta. {t(FOOTER_KEYS.RIGHTS)}{" "}
            <Link
              to="/politicasdeprivacidad"
              className="hover:text-white transition-colors"
            >
              {t(FOOTER_KEYS.PRIVACY_POLICY)}
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
